<template>
    <div>
        <div class="dh_p1a w-100">
            <div class="x_div_center" style="height:100%; background-color:rgba(0, 0, 0, 0.3);">
                <div class="rp_set px-3" style="padding:120px 0 0 0;">
                    <span class="dh_p1b">NEWS</span><br>
                    <span class="dh_p1c">{{ lang == 'ko' ? 'M3의 최신 소식을 알려 드립니다.' : 'Latest news of our company'
                        }}</span>
                </div>
            </div>
        </div>

        <div class="x_div_center">
            <div class="rp_set" style="border:0px solid red">

                <div class="p-3 pt-5">
                    <div class="" style="border-bottom:1px solid #e9e9e9"><span class="fkr-set2 fs-16"><strong>{{ lang
                        == 'ko' ? '뉴스' : 'NEWS' }}</strong></span></div>

                    <div style="border-bottom:1px solid #e9e9e9">
                        <div class="py-2 w-100">

                            <div class="py-2"><span class="fkr-set1 fs-15 fc-w10">전문건설공제조합-OSC모듈러산업협회, 모듈러 산업 활성화 위한
                                    업무협약 체결</span></div>
                            <div class="pb-2" style="border-bottom:1px solid #e9e9e9"><span class="fen-set2 fc-w3">Admin
                                    , 2026-02-26</span></div>
                            <div class="py-3">
                                <div class="px-2" style="line-height:180%">
                                    <span class="fkr-set2 fs-12">
                                        “건설의 제조화 전환 위한 정책적·제도적 기반 마련”<br /><br />
                                        <img src="@/assets/img/s_news/news_01.jpg" width="80%"
                                            style="display:block; margin:0 auto; border:1px solid #e9e9e9"><br /><br />
                                        전문건설공제조합과 OSC모듈러산업협회가 모듈러 산업 활성화와 건설산업의 제조 기반 전환을 위한 업무협약(MOU)을 지난 2월 26일에 체결했다.
                                        양 기관은 이번 협약을 통해 법·제도 개선, 정책 제안, 기술 연구, 교육, 전문인력 양성, 보증 및 금융 지원 기반 마련 등 다양한 분야에서
                                        협력을 확대해 나갈 계획이다.<br /><br />
                                        전문건설공제조합과 OSC모듈러산업협회가 모듈러 산업 활성화와 건설산업의 제조 기반 전환을 위한 협력 체계 구축에 나섰다.<br />
                                        양 기관은 최근 모듈러 산업 발전을 위한 유기적 협력체계 구축과 업계 지원·육성을 위한 공동 사업 발굴을 목적으로 업무협약(MOU)을 체결했다.
                                        이번 협약을 통해 양 기관은 법·제도 개선, 정책 제안, 기술 연구, 교육과정 개설, 전문인력 양성 등 다양한 분야에서 협력을 확대할
                                        계획이다.<br />
                                        이번 협약의 주요 내용은 OSC·모듈러 산업 발전을 위한 법·제도 개선 및 정책 제안, 관련 기술의 육성·진흥을 위한 연구·교류 및 지원사업
                                        발굴, 세미나·포럼 등 학술행사 개최를 위한 상호 협조, 전문건설공제조합 기술교육원을 활용한 교육과정 개설 및 전문인력 양성 지원, 기타 상호
                                        협력이 필요한 사항 등이다.<br /><br />
                                        김인한 OSC모듈러산업협회 회장은 협약식 인사말을 통해 “이번 협약은 단순한 기관 간 협력을 넘어 대한민국 건설산업이 현장 중심의 전통적 시공
                                        방식에서 제조 기반의 산업화 체계로 전환하는 출발점”이라고 밝혔다.<br />
                                        이어 “대한민국 건설산업은 숙련 인력의 고령화, 현장 안전 규제 강화, 생산성 정체, 탄소중립 이행 의무라는 중대한 과제에 직면해 있다”며
                                        “이제 건설은 기존의 현장 중심 시공 방식에서 벗어나 제조 기반 산업으로 전환해야 한다”고 강조했다.<br />
                                        김 회장은 또 “OSC는 공장에서 정밀화된 모듈을 생산하고 현장에서 조립하는 방식으로, 품질의 균질화, 공정의 예측 가능성 확보, 현장 안전성
                                        강화, 공사 기간 단축, 탄소 저감 등을 동시에 실현할 수 있는 구조적 혁신 모델”이라며 “OSC는 선택의 문제가 아니라 미래 건설산업의 표준을
                                        설계하는 국가 산업 전략”이라고 말했다.<br /><br />
                                        <img src="@/assets/img/s_news/news_02.jpg" width="80%"
                                            style="display:block; margin:0 auto; border:1px solid #e9e9e9"><br /><br />
                                        특히 이번 협약은 기술 협력을 넘어 금융·보증 체계 정비의 출발점이라는 점에서도 의미가 크다는 평가다. 모듈러 산업은 공장 설비 투자와 선제
                                        제작이 필요한 구조인 만큼, 기존 현장 중심 보증 체계와는 다른 리스크 평가 체계와 금융 인프라가 필요하다는 것이 업계의 공통된
                                        인식이다.<br />
                                        김 회장은 “이번 MOU는 구체적 사업과 제도 개선을 단계적으로 추진하기 위한 플랫폼 구축의 출발점이자, 건설산업 금융 인프라 전환을 준비하는
                                        실질적 기반”이라며 “모듈러 산업에 특화된 보증 상품과 금융 지원 체계가 구축된다면 회원사들은 보다 안정적인 환경 속에서 기술 혁신과 설비
                                        투자에 전념할 수 있을 것”이라고 밝혔다.<br />
                                        양 기관은 이번 협약을 계기로 모듈러 산업 관련 정책 연구와 제도 개선 논의를 확대하는 한편, 교육·학술·기술 교류를 통해 산업 생태계 기반을
                                        체계적으로 강화해 나갈 방침이다.<br />
                                        업계에서도 이번 협약이 모듈러 산업의 제도적 기반과 금융 지원 체계를 구체화하는 계기가 될지 주목하고 있다.<br /><br />
                                        ● OSC모듈러산업협회<br />
                                        담당부서: 기획국<br />
                                        담당자: 배병윤 국장<br />
                                        전화: 070-5038-6239<br />
                                        이메일: omia@omia.or.kr<br /><br />
                                        ● 전문건설공제조합<br />
                                        담당부서: 영업기획팀<br />
                                        담당자: 임효성 차장<br />
                                        전화: 02-3284-2045<br />
                                        이메일: hyosung@kfinco.co.kr</span>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>

                <div>
                    <div class="x_div_center py-3"><button class="fkr-set1 px-4 py-2"
                            style="width:120px; border:1px solid #e9e9e9" onclick="location.href='/menu/news'">{{ lang
                                ==
                                'ko' ? 'News 목록' : 'News List'}}</button></div>
                </div>

                <!-- <MenuFooter v-if="lang == 'ko'" /> -->
                <!-- <MenuFooter_En v-else-if="lang == 'en'" /> -->
            </div>
        </div>
    </div>
</template>

<script>
import MenuFooter from '@/components/MenuFooter.vue'
import MenuFooter_En from '@/components/MenuFooterEn.vue'
export default {
    name: 'NewsView01',
    props: {
        lang: {
            type: String,
            default: 'ko'
        }
    },
    components: {
        MenuFooter, MenuFooter_En
    }
}
</script>